import React, { PureComponent } from 'react';
import { getProfilesModuleClassName } from '../../helper/classNameHelper';
import { getClassNameGenerator } from '../../../../../../helper/className';

import './ProfilesAuthErrorPage.less';

export class ProfilesAuthErrorPage extends PureComponent {
  
  static className = getProfilesModuleClassName('auth-error-page');
  static getClassName = getClassNameGenerator(ProfilesAuthErrorPage.className);
  
  render() {
    return (
      <article className={ProfilesAuthErrorPage.className}>
        <h1 className={ProfilesAuthErrorPage.getClassName('heading', true)}>
          Oops, something went wrong.
        </h1>
        <p className={ProfilesAuthErrorPage.getClassName('message', true)}>
          Please tap 'Profiles' in the application menu to reload the screen.
        </p>
      </article>
    );
  }
  
}
